import { render, staticRenderFns } from "./FranchiseClinicProductsList.vue?vue&type=template&id=17f33dc4&"
import script from "./FranchiseClinicProductsList.vue?vue&type=script&lang=js&"
export * from "./FranchiseClinicProductsList.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseClinicProductsList.vue?vue&type=style&index=0&id=17f33dc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports